(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9570],{

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 92559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



var sendData = /*#__PURE__*/function () {
  var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var api, data, token, endpoint, headers, options, response;
    return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _ref.api, data = _ref.data, token = _ref.token;
            endpoint = api;
            headers = {
              "Content-Type": "application/json",
              "captcha-response": token
            };
            options = {
              method: "POST",
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 6;
            return fetch(endpoint, options);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (sendData);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 96065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ FiSearch; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiSearch(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 9570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ company_name_check; }
});

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(49711);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 2 modules
var react_select_esm = __webpack_require__(99973);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js + 3 modules
var index_a86253bb_esm = __webpack_require__(57003);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiSearch.js
var FiSearch = __webpack_require__(96065);
// EXTERNAL MODULE: ./components/atoms/Recaptcha/index.js
var Recaptcha = __webpack_require__(78762);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/components-tool/FormCheckNameCompany/Index.module.scss
var Index_module = __webpack_require__(79808);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/components-tool/FormCheckNameCompany/index.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var customSelectStyles = {
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      height: 40,
      minHeight: 40,
      fontSize: "14px",
      cursor: "pointer",
      borderRadius: "30px"
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontSize: "14px",
      margin: 0
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: "#B7B7B7",
      margin: 0,
      padding: 0
    });
  },
  singleValue: function singleValue(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: "#888888",
      padding: 0,
      height: "24px",
      margin: "8px 16px"
    });
  },
  option: function option(base, _ref) {
    var isSelected = _ref.isSelected;
    return _objectSpread(_objectSpread({}, base), {}, {
      color: isSelected ? "white" : "#333"
    });
  }
};
var customSelectStylesNation = {
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      height: 42,
      minHeight: 42,
      fontSize: "14px",
      margin: "0 8px"
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontSize: "14px"
    });
  }
}; // Dropdown

var Dropdown = function Dropdown(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      target = _ref2.target,
      onClose = _ref2.onClose;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative bg-bbc-white",
    children: [target, isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute z-20 w-full rounded-sm bg-bbc-white pt-2 shadow-lg",
      style: {
        height: "70px"
      },
      children: children
    }) : null, isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "fixed bottom-0 left-0 top-0 right-0 z-10",
      onClick: onClose
    }) : null]
  });
};

var IconSearch = function IconSearch() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FiSearch/* FiSearch */.j, {
    className: " mr-2 text-bbc-neutral-700"
  });
};

var CustomOption = function CustomOption(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.Option, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex cursor-pointer items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        style: {
          marginRight: 8,
          width: 25,
          height: 18
        },
        src: "/assets/flags/4x3/".concat(props.data.country_code.toLowerCase(), ".svg"),
        alt: "".concat(props.data.name.toLowerCase(), " flag")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm",
        children: props.data.name
      })]
    })
  }));
};

var CustomOptionDropdown = function CustomOptionDropdown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.Option, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "cursor-pointer text-sm",
        children: props.data.name
      })
    })
  }));
};

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    className: "m-0 mr-4 !p-0",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
      className: " text-base text-bbc-gray"
    })
  }));
}; // Let dropArrow = "scale(0.7)";


var arrowDown = function arrowDown() {// DropArrow = "scale(0.7)";
};

var FormCheckNameCompany = function FormCheckNameCompany(_ref3) {
  var _data$data, _country$EntityTypes, _entity$CompanySuffix, _errors$company_name, _errors$company_name2, _errors$first_name, _errors$email;

  var data = _ref3.data;
  var dataNotJersey = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.filter(function (item) {
    return item.id !== 111;
  });

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      locationRouter = _useContext.locationRouter;

  var countryList = dataNotJersey.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: item.name
    });
  });

  var countryListLocation = function countryListLocation() {
    var dataCountryFilter = {};

    if (locationRouter === "offshore") {
      dataCountryFilter = dataNotJersey === null || dataNotJersey === void 0 ? void 0 : dataNotJersey.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          value: item.name
        });
      });
    } else if (locationRouter === "hk") {
      dataCountryFilter = dataNotJersey === null || dataNotJersey === void 0 ? void 0 : dataNotJersey.filter(function (word) {
        return word.id === 98;
      });
    } else if (locationRouter === "sg") {
      dataCountryFilter = dataNotJersey === null || dataNotJersey === void 0 ? void 0 : dataNotJersey.filter(function (word) {
        return word.id === 191;
      });
    }

    return dataCountryFilter;
  };

  var countryInit = countryListLocation()[0];

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var recaptchaRef = (0,react.useRef)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var _useContext2 = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext2.openAlert;
  /** * Get Data Country ***/


  var _React$useState = react.useState(countryInit),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      country = _React$useState2[0],
      setCountry = _React$useState2[1];

  var handedOnchange = function handedOnchange(newCountry) {
    setCountry(newCountry);
    setOpen(!isOpen);
  };
  /** * Get Data EntityType ***/


  var dataEntityType = country === null || country === void 0 ? void 0 : (_country$EntityTypes = country.EntityTypes) === null || _country$EntityTypes === void 0 ? void 0 : _country$EntityTypes.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: item.name,
      label: item.name
    });
  });

  var _useState3 = (0,react.useState)(dataEntityType[0]),
      entity = _useState3[0],
      setEntity = _useState3[1];

  (0,react.useEffect)(function () {
    if (country) {
      if (dataEntityType.length > 0) {
        setEntity(dataEntityType[0]);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [country]);

  var onSelectEntity = function onSelectEntity(newEntity) {
    setEntity(newEntity);
  };
  /** * Get Data Suffix ***/


  var dataSuffix = (_entity$CompanySuffix = entity.CompanySuffixes) === null || _entity$CompanySuffix === void 0 ? void 0 : _entity$CompanySuffix.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: item.name,
      label: item.name
    });
  });

  var _React$useState3 = react.useState(dataSuffix[0]),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      suffixes = _React$useState4[0],
      setSuffixes = _React$useState4[1];

  (0,react.useEffect)(function () {
    if (entity && country) {
      setSuffixes(dataSuffix[0]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [entity, country]);

  var onSelectSuffixes = function onSelectSuffixes(newSuffixes) {
    setSuffixes(newSuffixes);
  };
  /** * OnSubmit ***/


  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                dataSend = _objectSpread({}, data);
                dataSend.captcha_response = token;
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country.id;
                dataSend.company_suffix_id = suffixes.id;
                dataSend.company_suffix_name = suffixes.name;
                dataSend.entity_type_id = entity.id; // Data.contact_from_id = 3;

                try {
                  (axios_default()); //   .post(
                  //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/check_name`,
                  //     Data,
                  //     {
                  //       Headers: {
                  //         "captcha-response": token,
                  //       },
                  //     }
                  // )

                  (0,post/* default */.Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/check_name"),
                    data: dataSend,
                    token: token
                  }).then(function (response) {
                    if (response.state) {
                      (0,trigger/* default */.Z)("contact_form", dataSend, "Check name - ".concat(country.name));
                      reset();
                      setCountry(countryInit);
                      openAlert(3000, "success");
                      clearErrors();
                    } else {
                      openAlert(3000, "error");
                      console.error();
                    }

                    setIsLoading(false);
                  })["catch"](function (error) {
                    openAlert(3000, "error");
                    console.log(error);
                  });
                } catch (e) {
                  // Reset();
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              } else {
                setIsLoading(false);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  /** ****/


  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Index_module_default()).wrapper),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      className: "mb-6 text-center text-lg font-semibold text-bbc-brand-700 lg:text-left",
      children: "Your proposed business name"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 relative mb-4  ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4 font-medium text-bbc-brand-700",
          children: "Nation*"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
          isOpen: isOpen,
          onClose: function onClose() {
            return setOpen(!isOpen);
          },
          target: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat(locationRouter === "hk" || locationRouter === "sg" ? "pointer-events-none select-none" : "cursor-pointer", " relative block h-10 w-full rounded-full border border-gray-300 bg-bbc-white px-4 py-2"),
            onClick: function onClick() {
              return setOpen(!isOpen);
            },
            disabled: Boolean(locationRouter === "hk" || locationRouter === "sg"),
            children: [country ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                style: {
                  marginRight: 8,
                  width: 25,
                  height: 18
                },
                src: "/assets/flags/4x3/".concat(country.country_code.toLowerCase(), ".svg"),
                alt: "".concat(country.name.toLowerCase(), " flag")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-sm text-[#888]",
                children: country.name
              })]
            }) : "Choose your country", locationRouter === "hk" || locationRouter === "sg" ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
              className: "absolute top-3 right-4"
            })]
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            className: (Index_module_default()).customSelectSearch,
            autoFocus: true,
            backspaceRemovesValue: false,
            controlShouldRenderValue: false,
            hideSelectedOptions: false,
            isClearable: false,
            menuIsOpen: true,
            options: countryList,
            placeholder: "Search...",
            tabSelectsValue: false,
            value: country,
            styles: customSelectStylesNation,
            components: {
              Option: CustomOption,
              IndicatorSeparator: function IndicatorSeparator() {
                return null;
              },
              DropdownIndicator: IconSearch
            },
            onChange: handedOnchange
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 mb-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4 font-medium text-bbc-brand-700",
          children: "Entity Name*"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
            placeholder: "Your proposed company name",
            type: "text"
          }, register("company_name", {
            required: {
              value: true,
              message: "This field is required"
            }
          })), {}, {
            className: "w-full rounded-full border border-gray-300 py-2 px-4 text-sm leading-6 text-bbc-gray placeholder-neutral-400 focus:ring-0"
          })), ((_errors$company_name = errors.company_name) === null || _errors$company_name === void 0 ? void 0 : _errors$company_name.type) === "required" && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block pl-2 pt-2 text-sm text-red-500",
            children: (_errors$company_name2 = errors.company_name) === null || _errors$company_name2 === void 0 ? void 0 : _errors$company_name2.message
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-6  lg:col-6 lg:mb-10 ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: "Entity Type*"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            options: dataEntityType,
            value: entity,
            components: {
              Option: CustomOptionDropdown,
              IndicatorSeparator: function IndicatorSeparator() {
                return null;
              },
              DropdownIndicator: DropdownIndicator
            },
            isSearchable: false,
            styles: customSelectStyles,
            onChange: onSelectEntity,
            onMenuClose: arrowDown
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-6  lg:col-6 lg:mb-10 ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: "Suffixes*"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            options: dataSuffix,
            value: suffixes,
            components: {
              Option: CustomOptionDropdown,
              IndicatorSeparator: function IndicatorSeparator() {
                return null;
              },
              DropdownIndicator: DropdownIndicator
            },
            isSearchable: false,
            styles: customSelectStyles,
            onChange: onSelectSuffixes,
            onMenuClose: arrowDown
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
        className: "mb-6 text-lg font-semibold text-bbc-brand-700",
        children: "Tell us how we can communicate with you about the result"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-6 lg:col-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: "First Name*"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register("first_name", {
            required: {
              value: true,
              message: "This field is required"
            }
          })), {}, {
            className: "w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none" // Disabled={isSubmitting}
            ,
            type: "text",
            placeholder: "Ex: Christian"
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block pt-2 pl-2 text-sm text-red-500",
            children: (_errors$first_name = errors.first_name) === null || _errors$first_name === void 0 ? void 0 : _errors$first_name.message
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-6 lg:col-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: "Last Name"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register("last_name")), {}, {
            className: "w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none",
            disabled: isSubmitting,
            type: "text",
            placeholder: "Ex: Chan"
          }))]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 mb-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4 font-medium text-bbc-brand-700",
          children: "Email Address*"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register("email", {
          required: {
            value: true,
            message: "Email is required"
          },
          pattern: {
            value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
            message: "Invalid e-mail"
          }
        })), {}, {
          className: " w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none",
          disabled: isSubmitting,
          type: "email",
          placeholder: "Ex: christian@gmail.com"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "block pt-2 pl-2 text-sm text-red-500",
          children: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-8",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            className: "text-[12px]",
            children: "*Note:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            className: "text-[12px]",
            children: "The information is required"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 mb-6 flex items-end justify-center lg:col-7 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "inline-block overflow-hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Recaptcha/* default */.Z, {
              ref: recaptchaRef,
              className: "mx-auto w-max"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "  mt-10 text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            id: "form-contact-button",
            type: "submit",
            onClick: function onClick() {
              if (isSubmitting) setIsLoading(true);
            },
            disabled: isLoading,
            btnDisplay: "inline-flex justify-center items-center",
            othersClass: "relative ",
            children: isSubmitting ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "flex items-center pr-0 lg:pr-5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
                className: "mr-2 inline-block animate-spin",
                size: 20
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "pl-3",
                children: "Loading"
              })]
            }) : "Send Your Message"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var components_tool_FormCheckNameCompany = (FormCheckNameCompany);
/** ========== */
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/company-name-check/index.js












var NewsSlider = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/offshore/guide-and-tool/company-name-check/index.js -> " + "components/organisms/NewsSlider"]
  }
});
/** ********/

var EntityNameCheck = function EntityNameCheck(_ref) {
  var _dataJson$banner;

  var dataJson = _ref.dataJson,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
        title: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$banner = dataJson.banner) === null || _dataJson$banner === void 0 ? void 0 : _dataJson$banner.title,
        titleProps: {
          className: "banner-default-title mb-6",
          textColor: "banner-title-default-color"
        },
        leftClassName: "lg:col-6",
        rightClassName: "lg:col-6",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/guide-and-tool/banner_name_check-offshore-tools.png",
          className: "h-full w-full",
          wrapper: {
            className: "bbc-banner-image-country pb-10 lg:pb-0 banner-lg-max-w-500"
          },
          width: 594,
          height: 444,
          alt: "banner-img"
        }),
        bgColor: "bg-bbc-country"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-10 lg:col-4 lg:mb-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              className: "title-h2 mb-9 text-bbc-brand-800 lg:mb-10",
              children: "Check Your Business Name For Free"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "If you\u2018re looking for registering a business, picking an eligible name is a must. Free Entity Name Check allows you to check the availability of your desired business name with no cost!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:col-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_tool_FormCheckNameCompany, {
                data: data.countries
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-9 text-bbc-brand-800 lg:mb-10",
          children: "Let Us Cover Your Need"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["We\u2018ve made it simple to find out your unique name!", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "What you need to do is just to complete the form with a few pieces of information. Please feel secured as we keep all of your information private. We will then check if it is available to reserve or already in use and inform you shortly."]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
        data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataHowItWork,
        className: "mb-10 lg:mb-20",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
          className: "text-center font-semibold lg:text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "text-3xl text-bbc-brand-800 lg:block lg:text-bbc-40px",
            children: ["How", " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-3xl text-bbc-brand-800 lg:block lg:text-4xl lg:leading-[44px] lg:text-bbc-brand-600",
            children: "It Works ?"
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:m-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            description: "Know more about our nominee service with commonly asked questions."
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var company_name_check = (EntityNameCheck);

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 79808:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSelectSearch":"Index_customSelectSearch__znJjB","wrapper":"Index_wrapper__WX5Aq"};

/***/ })

}]);